export default async ({ page: { locale } }) => {
  if (locale === 'en_US') {
    return true;
  }

  const momentLocale = locale.replace('_', '-').toLowerCase();

  try {
    await import(
      /* webpackChunkName: "moment-locales-[request]" */ `@narvar/moment-shim/locale/${momentLocale}.js`
    );
    return true;
  } catch (err1) {
    try {
      const momentLocaleNoCountry = momentLocale.replace(/-.*?$/, '');
      await import(
        /* webpackChunkName: "moment-locales-[request]" */ `@narvar/moment-shim/locale/${momentLocaleNoCountry}.js`
      );
      return true;
    } catch (err2) {
      return false;
    }
  }
};
